import {
  Button,
  CloseButton,
  Tooltip,
} from "@mantine/core";
import { useLanguage } from "../../stores/LanguageStore";

const DiffShow = ({ show, setShow, handleLoading }) => {
  const lang = useLanguage((s) => s.language);
  if (show)
    return (
      <Tooltip label={lang.contact_lists.job_finished}>
        <Button
          variant="white"
          onClick={() => {
            setShow(false);
            handleLoading(true);
          }}
          id="refresher"
          rightSection={
            <CloseButton
              component="span"
              size={"sm"}
              onClick={(e) => {
                e.stopPropagation();
                setShow(false);
              }}
            />
          }
        >
          {lang.contact_lists.update}
        </Button>
      </Tooltip>
    );
  return "";
};

export default DiffShow;
